<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div class="margin-bottom20" v-loading="loading">
    <div id="g2ede8" class="operations-content">
      <h2 id="gf7b16" class="operations-head-content detail_title_20">
        <div>
          <h2 class="operations-head margin-right40">
            {{ $t("SearchTrade.TradeTrends") }}
          </h2>
        </div>

        <div class="flex_between_box">
          <div class="perations-content-left margin-left20">
            <span
              :class="
                (activeIEports == '1'
                  ? 'perations-button perations-button-active'
                  : 'perations-button') +
                ' ' +
                (importFlag ? '' : 'cuspointno')
              "
              @click="importFlag ? ceckIEports('1') : ''"
            >
              {{ $t("SearchTrade.Imports") }}</span
            >
            <span
              @click="exportFlag ? ceckIEports('2') : ''"
              :class="
                (activeIEports == '2'
                  ? 'perations-button perations-button-active'
                  : 'perations-button') +
                ' ' +
                (exportFlag ? '' : 'cuspointno')
              "
              >{{ $t("SearchTrade.Exports") }}</span
            >
          </div>
        </div>
      </h2>

      <div class="Product_Supply_select flex_center_bettwen margin-top20">
        <div class="">
          <div v-show="false">{{ calDate }}</div>
          <el-date-picker
            class="limitDate"
            v-model="beginDate"
            type="month"
            :placeholder="$t('SearchTrade.Startdate')"
            value-format="yyyy-MM"
            :picker-options="beginPickerOptions"
          />
          <span class="font16 margin-left15 margin-right15">To</span>
          <el-date-picker
            class="limitDate"
            v-model="endDate"
            type="month"
            :placeholder="$t('SearchTrade.Enddate')"
            value-format="yyyy-MM"
            :picker-options="endPickerOptions"
          /> 

          <!-- <el-date-picker
            v-model="datePicker"
            @change="getTradeTrendsFilterList(2,false)"
            type="monthrange"
            range-separator=""
            :start-placeholder="$t('SearchTrade.Startdate')"
            value-format="yyyy-MM"
           :end-placeholder="$t('SearchTrade.Enddate')"
            class="product_supply_picher"
          ></el-date-picker> -->

          <el-select
            @change="getTradeTrendsFilterList(1, false)"
            clearable
            class="product_supply_select margin-left20"
            filterable
            :popper-append-to-body="false"
            v-model="HsCode"
            :placeholder="$t('SearchTrade.EnterHSCodeProductName')"
          >
            <el-option
              v-for="(item, index) in HsCodeList"
              :key="index"
              :label="item.nameEn"
              :value="item?.code"
            >
              <el-tooltip
                effect="dark"
                :content="item.nameEn"
                placement="top"
                :disabled="item?.nameEn?.length < 40"
              >
                <span
                  style="display: block; max-width: 100%; line-height: auto"
                  class="Country_name"
                >
                  {{ index + 1 }} {{ item.nameEn }}</span
                >
              </el-tooltip>
            </el-option>
          </el-select>
        </div>
        <el-button
          style="background: rgb(0, 158, 167) !important"
          class="btn_export"
          @click="getTradeTrendsFilterList(0, true)"
        >
          {{ $t("SearchTrade.Reset") }}</el-button
        >
      </div>

      <div class="margin-top20">
        <div ref="SupplyChainEchart" style="width: 100%; height: 540px"></div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>

<script>
import { formatNum } from "@/views/company/details/Background/utils";

import { getTabListOneLayer } from "@/api/userApi.js";
import { getTradeTrends, getTradeTrendsFilter } from "@/api/companyApi.js";
import ReLogin from "../../../../components/ReLogin.vue";
export default {
  name: "",
  // props: {},
  components: {
    ReLogin,
  },
  data() {
    return {
      data: {
        links: [],
        nodes: [],
      },
      Importyear: "",
      Country: "",
      companyList: [],
      Companyid: "",
      HsCodeList: [],
      HsCode: "",

      Countryoptions: ["China", "Japan", "Germany", "France", "Canada"],
      beginDate: "",
      endDate: "",
      beginPickerOptions: {
        disabledDate: (time) => {
          if (!this.endDate) return false;
          return time.getTime() > new Date(this.endDate).getTime();
        },
      },

      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.beginDate) return false;
          return time.getTime() < new Date(this.beginDate).getTime();
        },
      },

      datePicker: ["", ""],

      activeIEports: "1",
      importTrendListEcharts: [],

      reLoginVis: false,
      importFlag: false,
      exportFlag: false,
      loading: false,
    };
  },
  watch: {
    datePicker: {
      handler(newVal, oldVal) {
        this.getTradeTrendsFilterList(2, false);
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.getgetTabListOneLayerLsit();
    this.getTradeTrendsFilterList(0, true);
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    resizeFn() {
      this.suppleEchart();
    },
    SelectPicker() {
      this.datePicker = this.datePicker.sort(function (a, b) {
        return a - b;
      });
      this.getData();
    },
    ceckIEports(row) {
      this.activeIEports = row;
      this.getTradeTrendsFilterList(0, true);
    },

    getgetTabListOneLayerLsit() {
      this.loading = true;
      getTabListOneLayer({
        aaaId: this.$route.query.id3a,
        moduleId: 900,
      }).then((res) => {
        if (res.code == 200) {
          this.importFlag = res.data.find(
            (item) => item.name == "company_trade_trends_imports",
          ).isShow;
          this.exportFlag = res.data.find(
            (item) => item.name == "company_trade_trends_exports",
          ).isShow;
          this.activeIEports = this.importFlag ? 1 : 2;
          if (!this.importFlag) {
            this.ceckIEports("2");
          }
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },

    getTradeTrendsFilterList(value, isdefault) {
      this.loading = true;
      if (isdefault) {
        this.datePicker = ["", ""];
      }
      if (value == 0) {
        this.HsCode = "";
        this.Companyid = "";
        this.Country = "";
      }
      if (value == 1) {
        this.Companyid = "";
        this.Country = "";
      }

      getTradeTrendsFilter({
        startMonth: this.datePicker[0],
        type: this.activeIEports,
        endMonth: this.datePicker[1],
        aaaid: this.$route.query.id3a,
        hsCode: this.HsCode,
        modelType: 2,
      }).then((res) => {
        if (res.code == 200) {
          if (isdefault) {
            var year = res.data.lastTradeDate;
            this.beginDate = year + "-01";
            this.endDate = year + "-12";
          }
          this.HsCodeList = res.data.hsCodeList;
          this.companyList = res.data.companyList;
          this.Countryoptions = res.data.countryList;
          if (value == 0 || value == 2) {
            this.HsCode = res.data?.hsCodeList?.[0]?.code || "";
          }
          this.getData();
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
    suppleEchart() {
      let that = this;
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },

        grid: {
          left: "0%", // 设置左侧边距
          right: "0%",
          top: "7%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          right: "10px",
          top: "0px",
          itemGap: 40,
          // 其他图例配置项
          // ...
        },
        xAxis: {
          type: "category",
          data: that.importTrendListEcharts.map((item) => item.impYearMonth),
          axisTick: {
            show: false, // 不显示 x 轴上的间隔点
          },
          axisLabel: {
            color: "#1A2332", // 设置字体颜色
            fontSize: 14, // 可以在这里设置字体大小
            fontWeight: "normal", // 字体粗细
            fontFamily: "Arial, Arial", // 字体类型,
          },

          axisLine: {
            show: true,
            lineStyle: {
              width: 1,

              color: "#8497AB",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            splitNumber: 4,
            // inverse: true,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8497AB",
              },
            },

            // 背景虚线
            splitLine: {
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#8398BB",
              },
            },
            axisLabel: {
              show: true,
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: function (value) {
                return  formatNum(value)  ; // 格式化为千分位 
              },
            },
          },

          {
            type: "value",
            position: "right",
            alignTicks: true,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8398BB",
              },
            },
            // max:  that.ExporttableData.reduce((max, item) => (item.transactions > max ? item.transactions : max),  that.ExporttableData[0].transactions),
            axisLabel: {
              show: true,
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: function (value) {
                return value.toLocaleString() + "%"; // 格式化为千分位
              },
              color: "#FF7600", // 这里设置颜色，比如红色
            },
          },
        ],
        series: [
          {
            name: this.$t("SearchTrade.TradeVolume"),
            type: "bar",
            barWidth: "50",
            itemStyle: { color: "#009EA7", barBorderRadius: [5, 5, 0, 0] },
            barCategoryGap: "20%",
            emphasis: {
              itemStyle: {
                color: "#009EA7",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return "USD " +  formatNum(value) ;
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.amount),
          },
          {
            name:
              that.activeIEports == "1"
                ? this.$t("SearchTrade.MonthonMonthRatio")
                : this.$t("SearchTrade.MonthonMonthRatio"),
            type: "line",
            itemStyle: { color: "#FF7600" },
            yAxisIndex: 1,

            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return value + "%";
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => {
              // 判断值来决定图标和颜色
              const isAbove20 = item.growthRate > 0;

              return {
                value: item.growthRate,
                symbol: isAbove20
                  ? "path://M0,10 L10,0 L20,10 Z"
                  : "path://M0,0 L10,10 L20,0 Z", // 向上或向下三角形
                symbolSize: 20, // 设置大小
                itemStyle: {
                  color: isAbove20 ? "#FF6A6A" : "#1EFF0D", // 大于20为红色三角形，小于20为蓝色
                },
              };
            }),
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });
    },

    

    getData() {
      getTradeTrends({
        startMonth: this.datePicker[0],
        type: this.activeIEports,
        endMonth: this.datePicker[1],
        // aaaid:this.Companyid,
        hsCode: this.HsCode,
        modelType: 2,
        aaaid: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.importTrendListEcharts = res.data;

          this.suppleEchart();
        }
      });
    },
  },
  computed: {
    calDate() {
      this.datePicker = [this.beginDate, this.endDate];
      return this.datePicker;
    },
  },
};
</script>
<style scoped>
.operations-head {
  color: #009ea7;
}

.operations-content {
  padding: 30px 40px;
  height: 100%;
}

.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.table-content-color {
  color: #009ea7;
}

/deep/ .el-range-editor.el-input__inner {
  padding: 0px !important;
}
/deep/ .el-tag.el-tag--info {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #1a2332;
  font-size: 1.285714rem;
}
/deep/ .el-icon-close {
  display: none !important;
}
.Product_Supply_select {
  padding: 20px;
  background: #f5f5f5;
  border-radius: 5px;
}
/*cssStart*/
/deep/ .el-select-dropdown {
  max-width: 400px;
}
/deep/ .el-date-editor .el-range__close-icon {
  display: none !important;
}
.product_supply_select,
.product_supply_picher {
  width: 390px;
}
.product_supply_picher >>> .el-range-input {
  font-size: 16px;
}
.font26 {
  font-size: 26px !important;
}
.btn_export {
  border-radius: 5px;
  font-size: 16px;
  min-width: 120px;
  padding: 10px 20px;
}
.limitDate {
  width: 200px;
}
@media (max-width: 1920px) {
  .operations-content {
    padding: 22px 30px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }
  .Product_Supply_select {
    padding: 15px;
  }
  .supply_select {
    width: 292px;
  }
  .map_select >>> .el-input__inner {
    font-size: 16px;
  }
  .product_supply_select,
  .product_supply_picher {
    width: 300px;
  }
  .product_supply_picher >>> .el-range-input {
    font-size: 14px;
  }
  .font26 {
    font-size: 20px !important;
  }
  .btn_export {
    font-size: 14px;
    min-width: 90px;
    padding: 9px 20px;
  }
  .limitDate {
    width: 150px;
  }
}
@media screen and (max-width: 1439px) {
  .operations-content {
    padding: 20px 26px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }
  .Product_Supply_select {
    padding: 13px;
  }
  .supply_select {
    width: 262px;
  }
  .map_select >>> .el-input__inner {
    font-size: 14px;
  }
  .product_supply_select,
  .product_supply_picher {
    width: 290px;
  }
  .product_supply_picher >>> .el-range-input {
    font-size: 16px;
  }
  .font26 {
    font-size: 18px !important;
  }
  .limitDate {
    width: 120px;
  }
}
</style>
